import { localizedString } from '@languages';
import { DETAIL_MATCH } from '@spotMobileConfig';

const Model = {
  name: {
    isRequired: localizedString('pleaseEnterFirstName'),
    isRegexMatch: {
      message: localizedString('lettersAndSymbolsOnly'),
      regex: /^([a-zA-Z0-9 /`‘’'-]+)$/
    }
  },
  reference: {
    isRequired: localizedString('enterReferenceNumber'),
    isRegexMatch: {
      message: localizedString('lettersAndSymbolsOnly'),
      regex: /^([a-zA-Z0-9 /.`‘’'-]+)$/
    }
  }
};

const nModel = {};
Object.keys(Model).forEach((key) => {
  if (DETAIL_MATCH.includes(key)) {
    nModel[key] = Model[key];
  }
});

export default nModel;
